import walletStore from '@/src/stores/walletStore';
import type { WalletMessageEvent } from '../types';
import {
  MESSAGE_TYPE,
  type MessageType,
  SEND_MESSAGE_TYPE,
} from './messageHandlers';

export type PingEvent = WalletMessageEvent<typeof MESSAGE_TYPE.PING, null>;

export const isOnPing = (
  event: WalletMessageEvent<MessageType, unknown>
): event is PingEvent => {
  return event.data.type === MESSAGE_TYPE.PING;
};

export const onPing = (event: PingEvent) => {
  const { user } = walletStore.getState();
  if (user) {
    event.source?.postMessage(
      { type: SEND_MESSAGE_TYPE.ON_LOAD, data: user },
      { targetOrigin: event.origin }
    );
  }
};
